import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Box, Typography, Link } from '@mui/material';
import Iconify from '@/components/Iconify';
import { openUrl } from '@/utils/miscellaneous';

TicketDetails.propTypes = {
  iconify: PropTypes.any,
  iconBgColor: PropTypes.any,
  iconColor: PropTypes.any,
  iconSize: PropTypes.number,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  link: PropTypes.string,
  url: PropTypes.string,
  sx: PropTypes.object,
  nodeEnd: PropTypes.any,
};

export default function TicketDetails({
  iconify = '',
  iconBgColor = '',
  iconColor = 'text.secondary',
  iconSize = 16,
  title = '',
  subtitle = '',
  link = '',
  url,
  sx,
  nodeEnd,
  onClick = () => {},
  ...other
}) {
  const IconBlock = (
    <Box
      sx={{
        ...(iconBgColor
          ? {
              width: 16,
              height: 16,
              flexShrink: 0,
              display: 'flex',
              borderRadius: 1.5,
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: (theme) => theme.customShadows.z24,
            }
          : {}),
        color: iconColor || 'text.secondary',
      }}
    >
      <Iconify width={iconSize} height={iconSize} icon={iconify} />
    </Box>
  );
  return (
    <Stack
      direction="row"
      spacing={2}
      onClick={onClick}
      {...other}
    >
      <Stack
        direction="row"
        spacing={1}
        sx={{
          ...sx,
        }}
      >
        {iconify && IconBlock}
        <Box sx={{ flexGrow: 1, minWidth: 80 }}>
          {title && <Typography variant="body2">{title}</Typography>}
          <Stack direction="column" sx={{ mt: 0.5, color: 'text.secondary' }}>
            {subtitle && (
              <Typography variant="caption">
                {subtitle}
              </Typography>
            )}
            {link && (
              <Link
                variant="caption"
                sx={{
                  'textDecoration': 'underline',
                  '&:hover': {
                    cursor: 'pointer',
                  },
                }}
                onClick={() => {
                  if (url) {
                    openUrl(url);
                  }
                }}
              >
                {link}
              </Link>
            )}
          </Stack>
        </Box>
      </Stack>
      <Box sx={{ flexGrow: 1 }} />
      {nodeEnd && <>{nodeEnd}</>}
    </Stack>
  );
}
